module.exports = __webpack_public_path__ + "src/assets/img/brocken-glass.259c287f.svg";